import { render, staticRenderFns } from "./vehicleParkingRecord.vue?vue&type=template&id=db63615c&scoped=true&"
import script from "./vehicleParkingRecord.vue?vue&type=script&lang=js&"
export * from "./vehicleParkingRecord.vue?vue&type=script&lang=js&"
import style0 from "./vehicleParkingRecord.vue?vue&type=style&index=0&id=db63615c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db63615c",
  null
  
)

export default component.exports